/**
 * created by hezq on: 2022-10-10
 *
 * description： 插件入口api
 *
 */

import 'es6-promise/auto'
import pkg from '../package.json';
import behaviour from './behaviour.js'

const API = {
	version: pkg.version,
	init: behaviour.init,
	pushPageView: behaviour.pushPageView,
	pushClickEvent: behaviour.pushClickEvent
}

module.exports.default = module.exports = API



// WEBPACK FOOTER //
// ./src/index.js